var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"mt-12":"","pa-3":"","rounded":"","id":"top"}},[_c('v-row',{attrs:{"height":"100%"}},[_c('transition',{attrs:{"name":"spin"}},[_c('v-img',{attrs:{"src":require('../assets/jd-cube-border.png'),"contain":"","height":"325"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }